import React, { useState } from "react";
import AppetizersMenu from "./AppetizersMenu";
import DrinksMenu from "./DrinksMenu";
import HappyHourMenu from "./HappyHourMenu";
import PubGrubMenu from "./PubGrubMenu";
import appetizers from "../images/appetizers.jpg";
import pubgrub from "../images/pub-grub.jpg";
import drinks from "../images/drinks.jpg";
import happyhour from "../images/happy-hour.jpg";

const DesktopMenu = () => {
    const [index, setIndex] = useState(0);
    const images = [appetizers, pubgrub, drinks, happyhour];
    const menuComponents = [
        <AppetizersMenu />,
        <PubGrubMenu />,
        <DrinksMenu />,
        <HappyHourMenu />,
    ];

    return (
        <>
            <div className="left-box">
                <div className="menu-option-container">
                    <img src={images[index]} alt="menu-option" />
                </div>
            </div>
            <div className="right-box" id="desktop-menu">
                <div className="buttons">
                    <button className="button 1" onClick={() => setIndex(0)}>
                        Appetizers
                    </button>
                    <button className="button 2" onClick={() => setIndex(1)}>
                        Pub Grub
                    </button>
                    <button className="button 3" onClick={() => setIndex(2)}>
                        Drinks
                    </button>
                    <button className="button 4" onClick={() => setIndex(3)}>
                        Happy Hour
                    </button>
                </div>
                {menuComponents[index]}
            </div>
        </>
    );
};

export default DesktopMenu;
